import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CommunityTransactionForPurchaseQuery, CommunityTransactionForPurchaseQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CommunityTransactionForPurchaseQuery)
@Wrapper(CommunityTransactionForPurchaseQueryHandlerBase)
export class CommunityTransactionForPurchaseQueryHandler {
    public constructor(
        http: Http
    ) { }
}
